<template>
  <div :name="inputId" :id="inputId">
    <div class="store-hours" v-for="(day, index) in weekdaysData" v-if="showAllDaysOfWeek">
      <div class="row form-group ml-2 store-hours-row">
        <div class="col-md-1">
          <div class="form-group">
            <label for="daySwitch">{{day.dayOfWeek.split('/')[3]}}</label>
            <c-switch
              type="3d"
              v-if="showToggleDay"
              variant="primary"
              size="sm"
              v-model="toggleDays[index]"
              v-on:change="handleEnableDay($event, index)"
            ></c-switch>
          </div>
        </div>

        <div class="col-md-1" v-if="(showToggleDay && toggleDays[index]) || !showToggleDay">
          <div class="form-group">
            <label v-if="!day.open" for="allDayHolidayCheck">{{closedLabel}}</label>
            <label v-else for="allDayHolidayCheck">Open</label>
            <br>
            <c-switch
              :name="`${inputId}-_closedAllDay-${index}`"
              type="3d"
              variant="primary"
              size="sm"
              v-model="day.open"
              v-on:change="handleStoreOpen($event, index)"
            ></c-switch>
          </div>
        </div>
        <div
          class="col-md-1"
          v-if="day.open && ((showToggleDay && toggleDays[index]) || !showToggleDay)"
        >
          <div class="form-group">
            <label for="allDayHolidayCheck">{{allDayLabel}}</label>
            <br>
            <c-switch
              :name="`${inputId}-allDayHolidayCheck-${index}`"
              type="3d"
              variant="primary"
              size="sm"
              v-model="day.allDay"
              v-on:change="handleAllDay($event, index)"
            ></c-switch>
          </div>
        </div>
        <div
          class="col-md-2"
          v-if="day.open && !day.allDay && ((showToggleDay && toggleDays[index]) || !showToggleDay)"
        >
          <label>{{opensLabel}}</label>
          <div class="hours-events" v-for="(storehour, eventindex) in day.events">
            <div class="input-group mb-2">
              <vue-timesuggest
                v-bind:value="storehour.opens"
                :inputname="genLabel(index, 'open', eventindex)"
                v-on:input="handleUpdateBusinessHour($event, storehour, 'opens')"
                @selected="handleUpdateBusinessHour($event, storehour, 'opens')"
              />
            </div>
          </div>
        </div>
        <div
          class="col-md-3"
          v-if="day.open && !day.allDay && ((showToggleDay && toggleDays[index]) || !showToggleDay)"
        >
          <label>{{closesLabel}}</label>
          <div class="hours-events" v-for="(storehour, eventindex) in day.events">
            <div class="input-group mb-2">
              <vue-timesuggest
                v-model="storehour.closes"
                :inputname="genLabel(index, 'close', eventindex)"
                v-on:input="handleUpdateBusinessHour($event, storehour, 'closes')"
              />
              <Button
                class="btn btn-sm btn-danger ml-2"
                @click="removeEventFromWeekday(day, eventindex)"
              >
                <i class="fa fa-remove"></i>
              </Button>
            </div>
          </div>
        </div>
        <div
          class="col-md-2"
          v-if="day.open && !day.allDay && ((showToggleDay && toggleDays[index]) || !showToggleDay)"
        >
          <label>&nbsp;</label>
          <div class="form-group vertical-align">
            <Button class="btn btn-sm btn-success" @click="handleAddEventToWeekday(day, index)">
              <i class="fa fa-plus"></i>&nbsp;Add Hours
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div class="store-hours" v-for="(day, index) in holidaysData" v-if="!showAllDaysOfWeek">
      <div class="row form-group ml-2 store-hours-row">
        <div v-if="showDayOfWeek && false" class="col-md-2">
          <label>{{dayOfWeekLabel}}</label>
          <select
            :name="`${inputId}_dayOfWeek_${index}`"
            class="form-control"
            v-model="day.dayOfWeek"
          >
            <option value>NONE</option>
            <option value="http://schema.org/Monday">Mon</option>
            <option value="http://schema.org/Tuesday">Tue</option>
            <option value="http://schema.org/Wednesday">Wed</option>
            <option value="http://schema.org/Thursday">Thur</option>
            <option value="http://schema.org/Friday">Fri</option>
            <option value="http://schema.org/Saturday">Sat</option>
            <option value="http://schema.org/Sunday">Sun</option>
          </select>
        </div>

        <div v-if="showValidFrom || showValidThrough" class="col-md-2">
          <div class="row">
            <div class="col-md-12">
              <label v-if="showValidFrom">{{dateFromLabel}}</label>
              <datepicker
                :value="genDate(day.validFrom)"
                validationRule="required"
                :inputId="`${inputId}_validFrom_${index}`"
                v-on:updated="updatedDateFrom"
                :index="index"
                v-if="showValidFrom"
              ></datepicker>
              <br>
              <label v-if="showValidThrough">{{dateThroughLabel}}</label>
              <datepicker
                v-if="showValidThrough"
                validationRule="required"
                :value="genDate(day.validThrough)"
                :inputId="`${inputId}_validThrough_${index}`"
                v-on:updated="updatedDateThrough"
                :index="index"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="col-md-1" v-if="showClosed">
          <div class="form-group">
            <label for="allDayHolidayCheck" v-if="day._closedAllDay">
              {{closedLabel}}
              <br>
            </label>
            <label for="allDayHolidayCheck" v-if="day._open">Open</label>
            <br>
            <c-switch
              :name="`${inputId}-_closedAllDay-${index}`"
              type="3d"
              variant="primary"
              size="sm"
              v-on:change="updatedClosedAllDay($event, index, day)"
              v-model="day._open"
            ></c-switch>
          </div>
        </div>
        <div class="col-md-1" v-if="day._open">
          <div class="form-group">
            <label for="allDayHolidayCheck">{{allDayLabel}}</label>
            <br>
            <c-switch
              name="allDayHolidayCheck"
              :name="`${inputId}-allDayHolidayCheck-${index}`"
              type="3d"
              variant="primary"
              size="sm"
              v-on:change="handleHolidayAllDay($event, index, day)"
              v-model="day._allDay"
            ></c-switch>
          </div>
        </div>
        <div class="col-md-2" v-if="!day._closedAllDay && !day._allDay">
          <label>{{opensLabel}}</label>
          <div class="input-group">
            <vue-timesuggest
              v-model="day.opens"
              :inputname="genLabel(index, 'opensHoliday')"
              v-on:input="handleUpdateHolidayHour($event, day, 'opens')"
              v-bind:validations="day._open ? 'date_format:h:mma|required' : ''"
            />
          </div>
        </div>
        <div class="col-md-2" v-if="!day._closedAllDay && !day._allDay">
          <label>{{closesLabel}}</label>
          <div class="input-group" v-if="day._closesHMS">
            <vue-timesuggest
              v-model="day.closes"
              :inputname="genLabel(index, 'closesHoliday')"
              v-on:input="handleUpdateHolidayHour($event, day, 'closes')"
              v-bind:validations="day._open ? 'date_format:h:mma|required' : ''"
            />
          </div>
        </div>

        <div v-if="showDescription" class="col-md-3">
          <label>Description</label>
          <div class="input-group">
            <textarea v-model="day.description" class="form-control" rows="3" cols="4" v-on:change="handleDescriptionUpdated()" />
          </div>
        </div>
        <div class="col-md-1 gl-action-col">
          <div class="form-group">
            <Button @click="removeHolidayHour(index)" class="btn btn-sm btn-danger">
              <i class="fa fa-remove"></i> Delete
            </Button>
          </div>
        </div>
      </div>
      <hr>
    </div>

    <div v-if="!showAllDaysOfWeek">
      <hr style="height:3px;background-color:#DDDDDD;">
      <div class="row form-group ml-2 store-hours-row">
        <div class="col-md-4" v-if="!editData.clearBatchHourSwitchEnabled">
          <div class="form-group vertical-align" >
            <Button @click="addHoliday()" class="btn btn-sm btn-success">
              <i class="fa fa-plus"></i>
              &nbsp;{{getAddLabel()}}
            </Button>
            <Button
              v-if="showPopulateMatchesButton"
              @click="populateMatches()"
              class="btn btn-sm btn-info"
            >
              <i class="fa fa-plus"></i>&nbsp;Populate Hours
            </Button>

          </div>
        </div>
        <div class="col-md-4" v-if="showBatchClearSwitch">
           <c-switch
              name="clear-holiday-hours-batch"
              type="3d"
              variant="primary"
              size="sm"
              v-model="editData.clearBatchHourSwitchEnabled"
              v-on:change="clearBatchHourSwitchUpdated($event)"
            ></c-switch>
            <label>Clear Holiday Hours For {{batchLocationCount}} Locations</label>
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
  import $ from 'jQuery'
  import _ from 'lodash'
  import Vue from 'vue'
  import VueTimepicker from './gl-vue-timepicker'
  import VueTimeSuggest from './gl-timesuggest'
  import VeeValidate from 'vee-validate'
  import datemixin from './date-mixin.js'
  import GLDatePicker from './runtime-datepicker'
  import Switch from './switch.vue'
  import moment from 'moment'
  import VueMomentJS from 'vue-momentjs'
  Vue.use(VueMomentJS, moment)
  Vue.use(VeeValidate, { fastExit: false })

  const DATE_FORMAT = 'YYYY-MM-DD'
  const DATE_FORMAT_WITH_HOUR = 'YYYY-MM-DD HH:mm:ss'
  export default {
    name: 'RunTimeHours',
    inject: ['$validator'],
    props: {
      inputId: { type: String, default: 'RunTimeHoursComponent' },
      value: undefined,
      index: undefined,
      showToggleDay: { type: Boolean, default: true },
      showValidFrom: { type: Boolean, default: false },
      showValidThrough: { type: Boolean, default: false },
      showDayOfWeek: { type: Boolean, default: false },
      showAllDaysOfWeek: { type: Boolean, default: false },
      showDescription: { type: Boolean, default: false },
      showClosed: { type: Boolean, default: true },
      allDayChecked: { type: Boolean, default: false },
      optionalFields: { type: Array, default: function () { return [] } },
      dayOfWeekLabel: {type: String, default: 'Day of Week'},
      dateFromLabel: {type: String, default: 'Date From'},
      dateThroughLabel: {type: String, default: 'Date Through'},
      closedLabel: {type: String, default: 'Closed'},
      allDayLabel: {type: String, default: '24 hours'},
      opensLabel: {type: String, default: 'Opens'},
      closesLabel: {type: String, default: 'Closes'},
      showPopulateMatchesButton: { type: Boolean, default: false },
      showBatchClearSwitch: { type: Boolean, default: false },
      batchLocationCount: { type: Number, default: 0 }
    },
    components: {
      'vue-timepicker': VueTimepicker,
      'vue-timesuggest': VueTimeSuggest,
      'c-switch': Switch,
      'datepicker': GLDatePicker
    },
    mixins: [datemixin],
    data: function () {
      return {
        editData: {
          newDayOfWeek: '',
          newHolidayDateFrom: moment().toDate(),
          newHolidayDateThrough: '',
          newHolidayDescription: '',
          clearBatchHourSwitchEnabled: false,
          newHourOpen: {
            h: '9',
            mm: '00',
            A: 'AM'
          },
          newHourClose: {
            h: '5',
            mm: '00',
            A: 'PM'
          },
          _allDay: false,
          _closedAllDay: false
        },
        toggleDays: [false, false, false, false, false, false, false],
        holidaysData: [

        ],
        weekdaysData: [
          { 'dayOfWeek': 'http://schema.org/Sunday',
            'closed': false,
            'open': false,
            '_enabled': false,
            'allDay': false,
            'events': [
              {
                'opens': '',
                'closes': ''
              }
            ]
          }
        ]
      }
    },
    watch: {
      value: function (newValue, oldValue) {
        if (this.showDayOfWeek) {
          this.updateWeekMapData(newValue)
        } else {
          // holiday hours
          this.updateDayListData(newValue)
        }
      }
    },
    created: function () {
      this.$parent.$emit('child-validation', this.validateAll)
      this.$parent.$on('validation-errors', (errors) => {
        let err = errors.items.find(e => e.field === this.inputId)
        if (err) {
          console.log(err)
          $('#' + this.inputId).css('border', 'red solid 1px')
        } else {
          $('#' + this.inputId).css('border', '')
        }
      })
      if (this.showDayOfWeek) {
        this.updateWeekMapData(this.value)
      } else {
        this.updateDayListData(this.value)
      }
    },
    methods: {
      populateMatches: function () {
        this.$parent.$emit('populate-matches', this.inputId)
      },
      validateAll: function () {
        let ok = true
        if (this.value) {
          for (let i = 0; i < this.value.length; i++) {
            ok = this.validateItem(i)
            if (!ok) {
              return false
            }
          }
        }
        return ok
      },
      getAddLabel: function () {
        if (this.showValidFrom && !this.showDayOfWeek) {
          return 'Add New Date'
        } else if (!this.showValidFrom && this.showDayOfWeek) {
          return 'Add New Day'
        }
        return 'Add New Time'
      },
      removeHolidayHour: function (index) {
        // this.editData.holidayHoursSpecification.splice(index, 1)
        let newlist = this.genDayListDataForEmit()
        newlist.splice(index, 1)
        this.emitProp(newlist)
      },
      applyBorderError: function (id) {
        // $('#' + id).addClass('is-invalid')
        // Using Directly DOM to force border, jQuery not working
        const el = document.getElementsByName(id)[0]
        if (el) {
          el.setAttribute('style', 'border: 1px solid red !important;')
        }
        // $(el).css('border', '1px solid red !important')
      },
      clearBatchHourSwitchUpdated: function (event) {
        console.log(this.editData.clearBatchHourSwitchEnabled)
        this.$parent.$emit('clear-all-holidays', event)
        if (event) {
          this.emitProp([])
        }
      },
      validateItem: function (index) {
        let ok = true
        if (this.showValidFrom) {
          let validFromId = this.inputId + '_validFrom_' + index
          let validThroughId = this.inputId + '_validThrough_' + index
          if (!this.value[index].validFrom) {
            ok = false
            this.applyBorderError(validFromId)
            alert('\'Date From\' can\'t be empty!')
          }
          let dt = this.$moment(this.value[index].validFrom, DATE_FORMAT)
          let fmtNewHolidayDateFrom = (dt.isValid()) ? dt.format(DATE_FORMAT) : ''
          let fmtNewHolidayDateThrough = ''
          if (this.value[index].validThrough) {
            dt = this.$moment(this.value[index].validThrough, DATE_FORMAT)
            fmtNewHolidayDateThrough = (dt.isValid()) ? dt.format(DATE_FORMAT) : ''
          }
          if (fmtNewHolidayDateThrough === '' && this.value[index].validThrough && !this.optionalFields.includes('showValidThrough')) {
            ok = false
            this.applyBorderError(validThroughId)
            alert('\'Date Through\' can\'t be empty!')
          }
          if (fmtNewHolidayDateFrom === '') {
            ok = false
            this.applyBorderError(validFromId)
            alert('\'Date From\' can\'t be empty!')
          }
          if (this.showValidThrough && fmtNewHolidayDateThrough !== '' && fmtNewHolidayDateThrough < fmtNewHolidayDateFrom) {
            ok = false
            this.applyBorderError(validThroughId)
            alert('\'Date Through\' can\'t be less than \'Date From\'!')
          }
          if (ok) {
            if (fmtNewHolidayDateFrom) {
              let dt = this.$moment(fmtNewHolidayDateFrom + ' 00:00:00', DATE_FORMAT_WITH_HOUR)
              if (dt.isValid()) {
                this.value[index].validFrom = dt.format()
              } else {
                this.value[index].validFrom = ''
              }
            }
            if (fmtNewHolidayDateThrough) {
              let dt = this.$moment(fmtNewHolidayDateThrough + ' 23:59:59', DATE_FORMAT_WITH_HOUR)
              if (dt.isValid()) {
                this.value[index].validThrough = dt.format()
              } else {
                this.value[index].validThrough = ''
              }
            }
          }
        }
        if (this.showDayOfWeek && this.value[index].dayOfWeek === '' &&
            !this.optionalFields.includes('showDayOfWeek')) {
          ok = false
          let dayOfWeekId = this.inputId + '_dayOfWeek_' + index
          this.applyBorderError(dayOfWeekId)
          alert('\'Day of week\' can\'t be empty!')
        }
        return ok
      },
      addHoliday: function () {
        var newHoliday = {
          '@context': 'http://schema.org',
          '@type': 'OpeningHoursSpecification',
          closes: '',
          validFrom: this.editData.newHolidayDateFrom,
          validThrough: this.editData.newHolidayDateThrough,
          opens: '',
          _opensHMS: this.editData.newHourOpen,
          _closesHMS: this.editData.newHourClose,
          description: this.editData.newHolidayDescription,
          _allDay: this.allDayChecked,
          _open: !this.editData._closedAllDay,
          _closedAllDay: this.editData._closedAllDay,
          dayOfWeek: this.editData.newDayOfWeek
        }
        let newlist = this.genDayListDataForEmit()
        newlist.push(newHoliday)
        this.emitProp(newlist)
      },
      handleHolidayAllDay: function (event, index, day) {
        if (event) {
          Vue.set(day, 'opens', '12:00am')
          Vue.set(day, 'closes', '11:59pm')
          Vue.set(day, '_closedAllDay', false)
          Vue.set(day, '_allDay', true)
        } else {
          Vue.set(day, 'opens', '')
          Vue.set(day, 'closes', '')
          Vue.set(day, '_allDay', false)
        }
        Vue.set(day, '_open', true)
        Vue.set(day, '_closedAllDay', false)
        Vue.set(this.holidaysData, index, day)
        var newlist = this.genDayListDataForEmit()
        this.emitProp(newlist)
      },
      updatedClosedAllDay: function (event, index, day) {
        Vue.set(day, '_closedAllDay', !event)
        Vue.set(day, '_allDay', false)
        Vue.set(day, '_open', event)
        Vue.set(day, 'opens', '')
        Vue.set(day, 'closes', '')
        Vue.set(this.holidaysData, index, day)
        let newlist = this.genDayListDataForEmit()
        this.emitProp(newlist)
      },
      updatedDateFrom: function (event) {
        // this.value[event.index].validFrom = this.$moment(event.date).format('YYYY-MM-DD')
        // this.value[event.index].validThrough = this.value[event.index].validFrom
        var newlist = _.cloneDeep(this.holidaysData)
        if (!event.date) {
          console.log('event has no date')
          newlist[event.index].validFrom = ''
          self.emitProp(newlist)
          return
        }
        let fmtNewHolidayDateFrom = this.$moment(event.date).format(DATE_FORMAT)
        let fmtNewHolidayDateThrough = this.$moment(event.date).format(DATE_FORMAT)
        newlist[event.index].validFrom = fmtNewHolidayDateFrom
        let dt = this.$moment(newlist[event.index].validThrough)
        if (this.showValidThrough && dt.isValid()) {
          fmtNewHolidayDateThrough = dt.format(DATE_FORMAT)
        } else {
          fmtNewHolidayDateThrough = ''
        }
        newlist[event.index].validThrough = fmtNewHolidayDateThrough

        if (this.showValidFrom) {
          if (fmtNewHolidayDateThrough && fmtNewHolidayDateThrough < fmtNewHolidayDateFrom) {
            newlist[event.index].validFrom = newlist[event.index].validThrough
            alert('\'Date Through\' can\'t be less than \'Date From\'!')
            return
          }
        }
        this.emitProp(newlist)
      },
      updatedDateThrough: function (event) {
        // this.value[event.index].validFrom = this.$moment(event.date).format('YYYY-MM-DD')
        // this.value[event.index].validThrough = this.value[event.index].validFrom
        var self = this

        if (this.showValidThrough) {
          var newlist = _.cloneDeep(this.value)

          if (!event.date) {
            newlist[event.index].validThrough = ''
            self.emitProp(newlist)
            return
          }

          let fmtNewHolidayDateFrom = this.$moment(newlist[event.index].validFrom).format(DATE_FORMAT)
          let dt = this.$moment(event.date)
          let fmtNewHolidayDateThrough = dt.format(DATE_FORMAT)
          if (!dt.isValid()) {
            fmtNewHolidayDateThrough = ''
          }
          if (this.showValidFrom) {
            if (fmtNewHolidayDateThrough < fmtNewHolidayDateFrom) {
              alert('\'Date Through\' can\'t be less than \'Date From\'!')
            }
          }
          newlist[event.index].validThrough = fmtNewHolidayDateThrough
          self.emitProp(newlist)
        }
      },
      updatedNewDateFrom: function (event) {
        this.editData.newHolidayDateFrom = this.$moment(event.date).toDate()
        if (!this.showValidThrough) {
          this.editData.newHolidayDateThrough = this.$moment(event.date).toDate()
        }
      },
      updatedNewDateThrough: function (event) {
        this.editData.newHolidayDateThrough = this.$moment(event.date).toDate()
      },
      handleUpdateBusinessHour: function (storeHour, hourField, hourType) {
        Vue.set(hourField, hourType, storeHour)
        if (storeHour != null && storeHour.length > 5) {
          var storeHours = this.weekMapToList(this.weekdaysData)
          this.emitProp(storeHours)
        } else if (storeHour === '') {
          storeHours = this.weekMapToList(this.weekdaysData)
          this.emitProp(storeHours)
        }
      },
      handleUpdateHolidayHour: function (storeHour, hourField, hourType) {
        Vue.set(hourField, hourType, storeHour)
        if (storeHour != null && storeHour.length > 5) {
          var storeHours = this.genDayListDataForEmit()
          this.emitProp(storeHours)
        } else if (storeHour === '') {
          storeHours = this.genDayListDataForEmit()
          this.emitProp(storeHours)
        }
      },
      handleDescriptionUpdated: function () {
        var storeHours = this.genDayListDataForEmit()
        this.emitProp(storeHours)
      },
      handleStoreClosed: function (event, dayIndex) {
        Vue.set(this.weekdaysData[dayIndex], 'closed', event)
        Vue.set(this.weekdaysData[dayIndex], 'open', !event)
        var storeHours = this.weekMapToList(this.weekdaysData)
        this.emitProp(storeHours)
      },
      handleStoreOpen: function (event, dayIndex) {
        Vue.set(this.weekdaysData[dayIndex], 'closed', !event)
        Vue.set(this.weekdaysData[dayIndex], 'open', event)
        var storeHours = this.weekMapToList(this.weekdaysData)
        this.emitProp(storeHours)
      },
      handleEnableDay: function (event, dayIndex) {
        Vue.set(this.weekdaysData[dayIndex], '_enabled', event)
        // var storeHours = this.weekMapToList(this.weekdaysData)
        let dayName = this.indexToDayName(dayIndex)
        this.$emit('daytoggle', event, dayName)
        // this.emitProp(storeHours)
      },
      handleAllDay: function (event, dayIndex) {
        var allDayEvents = []
        if (event) {
          allDayEvents.push({
            '@context': 'http://schema.org',
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: this.weekdaysData[dayIndex].dayOfWeek,
            opens: '00:00:00',
            closes: '23:59:00'
          })
        } else {
          allDayEvents.push({
            '@context': 'http://schema.org',
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: this.weekdaysData[dayIndex].dayOfWeek,
            opens: '',
            closes: ''
          })
        }
        Vue.set(this.weekdaysData[dayIndex], 'allDay', event)
        Vue.set(this.weekdaysData[dayIndex], 'events', allDayEvents)
        var storeHours = this.weekMapToList(this.weekdaysData)
        this.emitProp(storeHours)
      },
      indexToDayName: function (index) {
        var dayName = ''
        if (index === 0) {
          dayName = 'Sunday'
        } else if (index === 1) {
          dayName = 'Monday'
        } else if (index === 2) {
          dayName = 'Tuesday'
        } else if (index === 3) {
          dayName = 'Wednesday'
        } else if (index === 4) {
          dayName = 'Thursday'
        } else if (index === 5) {
          dayName = 'Friday'
        } else if (index === 6) {
          dayName = 'Saturday'
        }
        return 'http://schema.org/' + dayName
      },
      handleAddEventToWeekday: function (day, index) {
        if (day.events == null) {
          Vue.set(day, 'events', [])
        }
        var newEvent = {
          'opens': '',
          'closes': '',
          '_enabled': day._enabled
        }
        day.events.push(newEvent)
        Vue.set(this.weekdaysData, index, day)
        this.weekdaysData[index] = day
      },
      removeEventFromWeekday: function (day, eventindex) {
        day.events.splice(eventindex, 1)
        var storeHours = this.weekMapToList(this.weekdaysData)
        this.emitProp(storeHours)
      },
      weekMapToList: function (eventMap) {
        var self = this
        var storeHoursList = []
        console.log('aaa')
        _.forEach(eventMap, function (day) {
          _.forEach(day.events, function (event) {
            if (!day.closed) {
              console.log('ya')
              let dayEnabled = false
              if (day._enabled != null) {
                dayEnabled = day._enabled
              }
              storeHoursList.push({
                '@context': 'http://schema.org',
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: day.dayOfWeek,
                opens: event.opens !== '' ? self.convertFromUiTimeNew(event.opens) : '',
                closes: event.closes !== '' ? self.convertFromUiTimeNew(event.closes) : '',
                _enabled: dayEnabled
              })
            }
          })
        })
        return storeHoursList
      },
      updateWeekMapData: function (storeHoursData) {
        var DOWEditData = this.initWeekData()

        for (var hour in storeHoursData) {
          let dow = storeHoursData[hour]
          var idx = _.findIndex(DOWEditData, function (el) {
            return el.dayOfWeek === dow.dayOfWeek
          })
          DOWEditData[idx].allDay = dow.opens != null && dow.opens === '00:00:00' && dow.closes != null && dow.closes === '23:59:00'
          DOWEditData[idx].open = true
          DOWEditData[idx].closed = false
          console.log(dow._enabled)
          DOWEditData[idx]._enabled = dow._enabled
          DOWEditData[idx].events.push({
            opens: dow.opens !== '' ? this.convertToUiTimeNew(dow.opens) : '',
            closes: dow.closes !== '' ? this.convertToUiTimeNew(dow.closes) : ''
          })
        }
        for (var day in DOWEditData) {
          if (DOWEditData[day].events == null || DOWEditData[day].events.length === 0) {
            DOWEditData[day].open = false
            DOWEditData[day].closed = true
            DOWEditData[day].events.push({
              opens: '',
              closes: ''
            })
          }
        }
        this.weekdaysData = DOWEditData
      },
      updateDayListData: function (storeHoursData) {
        let self = this
        let newDays = []
        _.forEach(storeHoursData, function (holidayDay) {
          var newDay = _.cloneDeep(holidayDay)
          newDay.opens = newDay.opens !== '' ? self.convertToUiTimeNew(newDay.opens) : ''
          newDay.closes = newDay.closes !== '' ? self.convertToUiTimeNew(newDay.closes) : ''
          if (newDay._closedAllDay != null && newDay._closedAllDay) {
            newDay._open = false
          } else {
            newDay._open = true
          }
          newDays.push(newDay)
        })
        this.holidaysData = newDays
      },
      genDayListDataForEmit: function () {
        let newDays = []
        var self = this
        _.forEach(this.holidaysData, function (holidayDay) {
//          holidayDay._closedAllDay = holidayDay.opens != null && holidayDay.opens === '' && holidayDay.closes != null && holidayDay.closes === ''
          var newDay = _.cloneDeep(holidayDay)
          if (newDay._allDay == null) {
            newDay._allDay = newDay.opens != null && newDay.opens === '12:00am' && newDay.closes != null && newDay.closes === '11:59pm'
          }
          newDay.opens = newDay.opens !== '' ? self.convertFromUiTimeNew(newDay.opens) : ''
          newDay.closes = newDay.closes !== '' ? self.convertFromUiTimeNew(newDay.closes) : ''
//          console.log('from: ' + holidayDay.validFrom + ' to: ' + self.$moment(newDay.validFrom).format(DATE_FORMAT))
          newDay.validFrom = self.$moment(newDay.validFrom).format(DATE_FORMAT)
//          console.log('final date is: ' + newDay.validFrom)
          newDays.push(newDay)
        })
        return newDays
      },
      genLabel: function (idx1, openclose, idx2) {
        return idx1 + openclose + idx2
      },
      genDate: function (date) {
        let newDate = this.$moment(date, [DATE_FORMAT, moment.ISO_8601]).toDate()
        return newDate
      },
      genNotClosed: function (closed) {
        return !closed
      },
      initWeekData: function () {
        var data = []
        _.forEach(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], function (day) {
          data.push({
            'dayOfWeek': 'http://schema.org/' + day,
            'closed': false,
            'open': false,
            'allDay': false,
            'events': []
          })
        })
        return data
      },
      customFormatter: function (date) {
        return this.$moment(date).format(DATE_FORMAT)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// runtime-hours.vue?9c23d332